import { Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekDrawer = styled(Drawer)(({ theme }) => ({}));

export { PeekDrawer, PeekDrawer as default };
